import * as ActionType from '../../constants/actionType';

const initialState = {
  availableRoles: [],
  availableRoleRights: [],
};

export default function userManagementState(state = initialState, action = '') {
  switch (action.type) {
    case ActionType.SET_AVAILABLE_ROLES:
      return {
        ...state,
        availableRoles: action.data,
      };
    case ActionType.SET_AVAILABLE_ROLE_RIGHTS:
      return {
        ...state,
        availableRoleRights: action.data,
      };
    default:
      return state;
  }
}
